import React, { useState } from 'react'
import { Modal as AntModal, Tooltip, message as $message, Space, Button } from 'antd'
import CustomIcon from '@/components/CustomIcon'
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined'
import { applyCompanyUserProxyLinkAuthUsingGET } from '@/services/supplier'
import { requestSync } from '@/utils/requestUtils'
import copy from 'copy-to-clipboard'
import debounce from 'lodash/debounce'

import { Input } from '@/ui'
const debounceTimer = 300

const tableNameAndId = 'tableNameAndId'
const Content = ({ coId, options, onOk }) => {
    const [filterValue, setFilterValue] = useState<string>('')
    const [filterOptions, setFilterOptions] = useState<any[]>(options)

    const handelGoEnable = async item => {
        const res = await requestSync(() =>
            applyCompanyUserProxyLinkAuthUsingGET({
                coId: coId,
                uid: item.uid
            })
        )
        AntModal.confirm({
            title: '请复制给客户获取授权',
            content: res.data,
            cancelButtonProps: {
                style: {
                    display: 'none'
                }
            },
            okText: '复制',
            onOk() {
                copy(res.data, {
                    format: 'text/plain',
                    onCopy: () => {
                        $message.success('复制成功，请发送给用户')
                    }
                })
            }
        })
    }

    const onRest = () => {
        setFilterValue('')
        setFilterOptions(options)
    }
    const onSearch = () => {
        if (!filterValue) {
            setFilterOptions(options)
        } else {
            // 过滤出 item.userName 的数据
            setFilterOptions(
                (options as any[]).filter(item =>
                    (item.userName as String).toLocaleLowerCase().includes(filterValue.trim().toLocaleLowerCase())
                )
            )
        }
    }

    // 回车搜索

    const onKeyUp = debounce(event => {
        const noEnterEvent = !event?.target?.dataset?.keyenterevent
        if (noEnterEvent && (event.key === 'Enter' || event.code === 'Enter')) {
            onSearch()
        }
    }, debounceTimer)

    return (
        <>
            <Space>
                <Input
                    id={tableNameAndId}
                    style={{
                        width: 300
                    }}
                    onKeyUp={onKeyUp}
                    value={filterValue}
                    onChange={e => setFilterValue(e.target.value)}
                    placeholder="用户名"
                />
                <Button type="primary" onClick={onSearch}>
                    搜索
                </Button>
                <Button onClick={onRest}>重置</Button>
            </Space>
            <Space
                direction="vertical"
                style={{
                    maxHeight: 600,
                    overflowY: 'auto',
                    width: '100%',
                    marginTop: 8
                }}
            >
                {filterOptions.map(item => (
                    <div
                        style={{
                            display: 'flex'
                        }}
                        key={item.uid}
                    >
                        <div style={{ minWidth: 300, maxWidth: 350 }}>
                            {item?.roleType === 'admin' ? (
                                <CustomIcon type="icon-fuzerenxinxiweihu" />
                            ) : (
                                <CustomIcon type="icon-icon-wode" />
                            )}{' '}
                            {item.userName} ({item.uid}) {item.authorized ? null : <span>(未授权)</span>}{' '}
                        </div>
                        {item.authorized ? (
                            <a
                                style={{
                                    color: '#1890ff'
                                }}
                                onClick={() => onOk({ userData: item })}
                            >
                                [代理登录]
                            </a>
                        ) : (
                            <a onClick={() => handelGoEnable(item)}>[申请授权]</a>
                        )}
                    </div>
                ))}
            </Space>
        </>
    )
}

export default ({ visible, onOk, options, onCancel, coId, ...restProps }) => {
    return (
        <AntModal
            title={
                <div>
                    指定用户
                    <Tooltip
                        overlay={null}
                        placement="top"
                        overlayStyle={{ fontSize: '12px', maxWidth: '340px' }}
                        title={
                            <div>
                                <CustomIcon type="icon-fuzerenxinxiweihu" />
                                ：管理员 &emsp;
                                <CustomIcon type="icon-icon-wode" />
                                ：员工
                            </div>
                        }
                        color="rgba(0,0,0,0.7)"
                    >
                        <QuestionCircleOutlined key="Icon" style={{ marginLeft: '8px' }} />
                    </Tooltip>
                </div>
            }
            width="500px"
            footer={null}
            visible={visible}
            maskClosable={false}
            destroyOnClose={true}
            onCancel={onCancel}
            {...restProps}
        >
            <Content coId={coId} options={options.sort(item => (item.authorized ? -1 : 1))} onOk={onOk} />
        </AntModal>
    )
}
